export const Namespace = 'FOLDER';
export enum FolderAction {
   SelectAll = 'SELECT_ALL',
   OpenFolder = 'OPEN_FOLDER',
   OpenDocument = 'OPEN_DOCUMENT',
   Scan = 'SCAN',
   UploadDocument = 'UPLOAD_DOCUMENT',
   CreateDocument = 'CREATE_DOCUMENT',
   CreateFolder = 'CREATE_FOLDER'
};



// WEBPACK FOOTER //
// ./src/sharebase-app/components/folderView/folderView.actions.ts